import { PromotionItem } from '@/modules/settings/promotions/types/types.ts'

const promotionWithWeppaPlus: PromotionItem = {
  id: '1',
  name: 'Promo con Weppa Plus',
  isActive: true,
  quotes: '4',
  exchange: '1.25',
  timesQuotes: '14',
  initialPercentage: '30.00',
  noCreditLimits: false,
  startDate: '01/09/2026',
  endDate: '31/12/2026',
  clientTypeId: '1',
  clientTypeName: 'Cliente',
  brands: [{ id: '1', name: 'Xiaomi' }],
  models: [
    { id: '1', name: 'ZTE BLADE A56' },
    { id: '7', name: 'REDMI NOTE 12' }
  ],
  commercialAllies: [{ id: '3', name: 'Aliado 1' }],
  branchOffices: [{ id: '1', name: 'Weppa' }],
  rentabilityId: '1',
  description: 'Promoción con rentabilidad de Weppa Plus y rango de costo.',
  levelId: '1',
  levelName: 'Nivel 1 - Bronce',
  order: 1,
  insuranceRentabilityId: '35',
  insurancePercent: '5.00',
  minCost: '100.00',
  maxCost: '1000.00'
}

const promotionWithoutWeppaPlus: PromotionItem = {
  ...promotionWithWeppaPlus,
  id: '2',
  name: 'Promo sin Weppa Plus',
  isActive: false,
  description: 'Promoción sin los campos nuevos (todos opcionales).',
  order: null,
  insuranceRentabilityId: null,
  insurancePercent: null,
  minCost: null,
  maxCost: null
}

export const promotionsPage1 = {
  data: {
    results: [promotionWithWeppaPlus, promotionWithoutWeppaPlus],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}

export const promotionDetail1 = { data: promotionWithWeppaPlus }
export const promotionDetail2 = { data: promotionWithoutWeppaPlus }

export const clientTypesCatalog = {
  message: 'OK',
  data: [
    { id: '1', label: 'Cliente' },
    { id: '2', label: 'Empleado' }
  ]
}
